import { useMutation } from "react-query";
import { GetProducerCodeListByOfficeCode } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetProducerByOfficeCode = () => {
  return useMutation(GetProducerCodeListByOfficeCode);
};
